import React from "react";
import "./CardLeft.css";

type CardProps = {
  title?: string;
  children?: React.ReactNode;
};

export default function Card_left({ title, children }: CardProps) {
  return (
    <div className="card-left">
      {title && <h3 className="card-left-title">{title}</h3>}
      <div className="card-left-content">{children}</div>
    </div>
  );
}
